import CXMApiClient from "../CXMApiClient";
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";
import Vue from "vue";

function initialState() {
  return {
    AddVoiInfoModal: {
      showModal: false,
      lead: null,
      emitMethodtype: null,
      editMode: false,
      selectedVehicle: null
    },
    AddTradeInInfoModal: {
      showModal: false,
      emitMethodtype: null,
      lead: null
    },
    LeadTabChangeConfirmModal: {
      ShowModal: false,
      Description: "",
      type: "",
      modalData: null
    },
    RemoveVOIModalInfo: {
      showModal: false,
      data: null
    },
    ChooseVOIModalInfo: {
      showModal: false,
      data: null,
      type: null
    },
    AssignLeadModalInfo: {
      confirmationActionMethodName: null,
      showModal: false,
      alertMinerRoleNames: null,
      accountPlatformId: null,
      confirmationActionMethodName: null,
      data: null
    }
  };
}

const state = initialState();

const getters = {};

const actions = {
  setLeadTabChangeConfirmModal(context, val) {
    context.commit("LeadTabChangeConfirmModalShowModal", val);
  },
  getCrmLeadSourcesByPlatform(context, requestPayload) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest("POST", "/api/crmlead/leadsource/get", requestPayload)
        .then(resp => {
          if (resp.data && resp.data.successful && resp.data.data)
            resolve(
              resp.data.data.sort(HelperFunctions.sortByPropertyAsc("name"))
            );
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  fetchVehiclesForLead: function(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "GET",
          `/api/crmlead/${request.leadId}/${request.type}`,
          request.leadId,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful && resp.data.data)
            resolve(resp.data.data);
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  updateVoiInfoModal: function(context, data) {
    context.commit("updateVoiInfoModal", data);
  },
  updateTradeInInfoModal: function(context, data) {
    context.commit("updateTradeInInfoModal", data);
  },
  addVehicleToLead: function(context, request) {
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          `/api/CrmLead/${request.leadId}/${request.type}`,
          request.vehicle,
          request.scope ? [request.scope] : []
        )
        .then(resp => {
          if (resp.data && resp.data.successful && resp.data.data)
            resolve(resp.data.data);
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  updateVoiLeadVehicle: function(context, vehicle) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "PUT",
          `/api/CrmLead/${vehicle.crmLeadId}/voi/${vehicle.crmLeadVoiId}`,
          vehicle,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful && resp.data.data)
            resolve(resp.data.data);
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  updateTradeInLeadVehicle: function(context, vehicle) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "PUT",
          `/api/CrmLead/${vehicle.crmLeadId}/trade/${vehicle.crmLeadTradeId}`,
          vehicle,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful && resp.data.data)
            resolve(resp.data.data);
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  removeVehicleFromLead: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();
    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "DELETE",
          `/api/CrmLead/${request.type}/${request.id}`,
          null,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful && resp.data.data)
            resolve(resp.data.data);
          else reject(resp);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  updateRemoveVOIModal: function(context, data) {
    context.commit("updateRemoveVOIModal", data);
  },
  updateChooseVOIVehicleModal: function(context, data) {
    context.commit("updateChooseVOIVehicleModal", data);
  },
  updateAssignLeadModalInfo: function(context, data) {
    context.commit("updateAssignLeadModalInfo", data);
  },
  claimLead: function(context, request) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/pando/claimable_lead/claim_lead", request)
        .then(response => {
          if (response && response.data.Data && response.data.Data) {
            resolve(response.data.Data);
          } else reject(response.data.Data);
        })
        .catch(ex => {
          reject(ex);
        });
    });
  },
  assignLead: function(context, request) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/pando/claimable_lead/assign_lead", request)
        .then(response => {
          if (response && response.data.Data && response.data.Data) {
            resolve(response.data.Data);
          } else reject(response.data.Data);
        })
        .catch(ex => {
          reject(ex);
        });
    });
  }
};

const mutations = {
  updateVoiInfoModal: function(state, data) {
    if (!data.showModal) {
      data.editMode = false;
      data.vehicleData = null;
    }
    state.AddVoiInfoModal = data;
  },
  updateTradeInInfoModal: function(state, data) {
    if (!data.showModal) {
      data.editMode = false;
      data.vehicleData = null;
    }
    state.AddTradeInInfoModal = data;
  },
  LeadTabChangeConfirmModalShowModal(state, val) {
    state.LeadTabChangeConfirmModal.ShowModal = val.ShowModal;
    state.LeadTabChangeConfirmModal.Description = val.Description;
    state.LeadTabChangeConfirmModal.buttons = val.buttons;
  },
  updateRemoveVOIModal: function(state, val) {
    console.log(val)
    state.RemoveVOIModalInfo = val;
  },
  updateChooseVOIVehicleModal: function(state, val) {
    state.ChooseVOIModalInfo = val;
  },
  updateAssignLeadModalInfo: function(state, val) {
    state.AssignLeadModalInfo = val;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Leads.js